import { render, staticRenderFns } from "./ExtendedFormsGBS.vue?vue&type=template&id=03f924cf&"
import script from "./ExtendedFormsGBS.vue?vue&type=script&lang=js&"
export * from "./ExtendedFormsGBS.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedFormsGBS.vue?vue&type=style&index=0&id=03f924cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports